module.exports = __webpack_public_path__ + "static/running.c07149e9.png";